/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

import Cart from "cart-store"

(function()
{
    var variantMap = {};

    async function selectorClick(event)
    {
        event.preventDefault();

        if (event.target.tagName !== "BUTTON")
            return;

        let form = event.currentTarget.querySelector("form");
        if (form == null)
            return;

        let formData = new FormData(form);
        formData.append("id", event.target.dataset.variant);

        let data = Object.fromEntries(formData.entries());

        await Cart.add(data);
        await Cart.resetVariantsBeingAdded();
        
        const cart = document.querySelector(".modal--cart, .popup--cart-notification");

        if (cart && !cart.shown)
        {
            cart.open();
        }
        else if (cart && cart.interval)
        {
            cart.interval.reset();
            cart.interval.start();
        }
    }
    
    function swatchClick(event)
    {
        let selector    = event.currentTarget.closest("product-card").querySelector(".rl-size-selector");
        let color       = variantMap[event.currentTarget.getAttribute("variant-id")] ?? false;

        for (let v of selector.querySelectorAll("li[data-color]"))
            v.style.display = v.dataset.color !== color ? "none" : "";
    }

    for (let selector of document.querySelectorAll(".rl-size-selector"))
    {
        selector.addEventListener("click", selectorClick);

        let initialColor = selector.dataset.initialColor;
        for (let v of selector.querySelectorAll("li[data-color]"))
        {
            let b = v.querySelector("button[data-variant]");
            
            variantMap[b.dataset.variant]   = v.dataset.color;
            v.style.display                 = v.dataset.color !== initialColor ? "none" : "";
        }

        for (let s of selector.closest("product-card").querySelectorAll("product-card-variant-swatch"))
            s.addEventListener("click", swatchClick);
    }
})();